<template>
  <div>
    <el-upload
      :accept="accept"
      :action="uploadConfig.url"
      :multiple="false"
      :on-success="uploadSuccess"
      :before-upload="beforeUpload"
      :show-file-list="false"
      :on-error="errorHandle"
    >
      <el-button type="primary" size="mini" >选择文件</el-button>
      <div v-if="currentValue">{{currentValue}}</div>
    </el-upload>
    <div style="color: #f56c6c; font-size: 14px; font-weight: 500">
      {{ defaultPlaceHolder }}
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  components: {
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    maxSize: {
      type: Number,
      default: 3,
    },
    accept: {
      type: String,
      default: "*.doc,*.docx,*.png",
    },
    showTips: {
      type: Boolean,
      default: true,
    },
    backgroundColor: {
      type: String,
      default: "#FFF",
    },
    placeholder: {
      type: String,
      default: ``,
    },

  },

  watch: {

  },
  data() {
    return {
      uploadConfig: {
        url: "",
      },
      uploading: false,
    };
  },
  computed: {
    defaultPlaceHolder() {
      if (this.placeholder) {
        return this.placeholder;
      }
      return `文件大小不超过2M，格式支持:jpg,png,bmp,jpeg`;
    },
    currentValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
  created() {
    this.uploadConfig.url = `${
      window.SITE_CONFIG["apiURL"]
    }/sys/oss/upload?token=${Cookies.get("token")}`;
  },
  methods: {
    beforeUpload(file) {
      const isImg = true;
      const isLimit = file.size / 1024 / 1024 < this.maxSize;
      if (!isLimit) {
        this.$message.error(`文件大小不能超过 ${this.maxSize}MB!`);
      }
      const isContinue = isImg && isLimit;
      if (isContinue) {
        this.uploading = true;
      }
      return isContinue;
    },
    uploadSuccess(res, file, fileList) {
      this.uploading = false;
      if (res.code !== 0) {
        return this.$message.error(res.msg);
      }
      this.currentValue = res.data.src;
      this.$forceUpdate();
    },
    errorHandle(err, file, fileList) {
      this.uploading = false;
      this.$message.error("上传失败");
    },

  },
};
</script>

<style lang="scss" scoped>
.cropper-box {
  position: relative;
  width: 500px;
  height: 500px;
  .cropper-btn {
    z-index: 100;
    position: absolute;
    top: 5px;
    right: 5px;
    width: 100px;
    display: flex;
    justify-content: flex-end;
  }
}
.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border: 1px dashed #e1e1e1;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.4s;
  .btn-upload {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    font-weight: 500;
    padding-top: 20px;
    .icon-upload {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 8px;
    }
  }
}
.upload-box:hover {
  border-color: #f56c6c;
}
</style>
